module.exports = __webpack_public_path__ + "img/aceptar.5f240735.svg";